import { AiOutlineLogin } from "react-icons/ai";
import { RiCommunityFill } from "react-icons/ri";
import { MdDisabledVisible } from "react-icons/md";
import { useLocation } from 'react-router-dom';
import React, { useState } from "react";
import AboutUs from "./AboutUs";
import Modal from "./Modal"
import Footer from "./Footer";
import UseCasesPage from "./UseCasesPage"; 


export default function Login() {
  let location = useLocation();
  const [alertText, setAlertText] = useState();
  const [showModal, setShowModal] = useState(false)

  const onlogin = () => {
    const link = "/api/login";
    window.location.replace(link);
  };

  React.useEffect(() => {
    setAlertText(location?.state?.error)
  }, [location]);
  return (
    <section>
      <div class=" col-span-10 bg-blue-100 border-blue-500 text-blue-700 px-2 py-2 relative" role="alert" style={{ display: alertText ? "block" : "none" }}>
      <button className="absolute top-2 right-1 text-lg font-normal text-gray-700 -translate-x-2 " onClick={()=> {setAlertText(undefined)}}>X</button><span class="text-sm">{alertText} </span>
      </div>
      <div className="py-4 px-3 mx-auto max-w-screen-xl text-center lg:py-8">
        <div className="flex justify-center mb-4">
          <button className="flex items-center gap-2 px-5 py-3 text-3xl font-medium text-white bg-blue-600 rounded-md shadow hover:bg-blue-700 hover:shadow-md transition duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" id="login" onClick={() => setShowModal(true)}>
            <AiOutlineLogin className="w-5 h-5" />
            <span>Login</span>
          </button>
        </div>
        <h2>This is ONLY used for Single Sign On (we do not collect any information)</h2>
        <h1 className="mb-3 text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight leading-tight text-white">
          A Community for Secure Sharing <br/>
          and Easy Content Management
        </h1>
        <p className="mb-4 text-sm sm:text-base lg:text-lg text-gray-300 px-4 sm:px-8 lg:px-24">
          JustWhere is a community of privacy-respecting service providers. It helps you securely and easily share content (like documents, images, videos, employee and insurance info) with family, friends, and professionals!
        </p>
      </div>

      <UseCasesPage/>
      <div class="grid md:grid-cols-2 gap-8 px-4">
        <div class="border border-gray-700 rounded-lg p-8 md:p-12">
          <RiCommunityFill size="2rem" />
          <h2 class="text-white text-3xl font-extrabold mb-2">You are in control</h2>
          <p class="text-lg font-normal text-gray-400 mb-4">Choose precisely who sees your content and for how long. When details change, only those you have shared with get
            the latest one automatically.</p>
        </div>
        <div class="border border-gray-700 rounded-lg p-8 md:p-12">
          <MdDisabledVisible size="2rem" />
          <h2 class="text-white text-3xl font-extrabold mb-2">Safe & private storage</h2>
          <p class="text-lg font-normal text-gray-400 mb-4">Rest assured your contents (like addresses) are stored securely with top notch encryption and visible only to people you choose on JustWhere community.</p>
          <a className="text-blue-500 bg-slate-333 hover:bg-555 hover:underline" href="#/security-report" target="_blank">View Security Reports</a>
        </div>
      </div>

      <div class="py-4 px-2 mx-auto max-w-screen-xl text-left lg:py-16"><AboutUs /></div>
      <Footer />

      {
        showModal && <Modal onClose={() => setShowModal(false)} login={onlogin} />
      }
    </section>
  )
};


